"use client"
import { useEffect, useState } from "react"
import Link from "next/link"
import "@/components/fbd/fbd.css"
import { SiteHeader, SiteFooter, PdfCover, Check, Arrow } from "@/components/fbd/ui"
import { PDF_PRODUCT } from "@/lib/pdf-product"

const INCLUDED = [
  "Un planning sur 60 jours",
  "Des séances détaillées (séries, répétitions, repos)",
  "Des exercices expliqués, placement et erreurs à éviter",
  "Un cardio progressif",
  "Du renforcement bas, haut du corps et full body",
  "Un suivi de progression à cocher",
  "Mes conseils pour rester régulière",
]

const STEPS = [
  { n: "01", title: "Tu paies en ligne", text: "Paiement sécurisé par Stripe : carte bancaire, Apple Pay ou Google Pay." },
  { n: "02", title: "Tu reviens ici", text: "Stripe te redirige automatiquement vers ta page de téléchargement." },
  { n: "03", title: "Tu commences", text: "Ton PDF est à toi : sur ton téléphone, ta tablette, ou imprimé." },
]

export default function CoachingPdfPage() {
  const [paying, setPaying] = useState(false)
  const [error, setError] = useState(null)
  const [canceled, setCanceled] = useState(false)

  useEffect(() => {
    setCanceled(new URLSearchParams(window.location.search).get("annule") === "1")
  }, [])

  const handlePurchase = async () => {
    setPaying(true)
    setError(null)
    try {
      const res = await fetch("/api/pdf/checkout", { method: "POST" })
      const data = await res.json()
      if (!res.ok || !data.url) throw new Error(data.error)
      window.location.href = data.url
    } catch (e) {
      setError(e.message || "Impossible de lancer le paiement. Réessaie dans quelques minutes.")
      setPaying(false)
    }
  }

  return (
    <div className="fbd" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <SiteHeader cta={<span style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 600, color: "#7A5D67" }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#A8506A" strokeWidth="2.2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></svg>
        <span className="hide-m">Paiement sécurisé</span>
      </span>} />

      <main className="shop-main" style={{ flex: 1 }}>
        <div className="wrap shop-grid" style={{ position: "relative" }}>
          {/* Le produit */}
          <div>
            <Link href="/" className="ul" style={{ display: "inline-block", marginBottom: 28, fontSize: 14, fontWeight: 600, color: "#7A5D67" }}>← Retour à l’accueil</Link>
            <div className="kicker" style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <span style={{ width: 32, height: 1, backgroundColor: "#C46F88" }} />PROGRAMME FITNESS · 60 JOURS
            </div>
            <h1 className="t-hero" style={{ marginTop: 20 }}>
              Affiner, tonifier<br />& <em className="em">briller</em>.
            </h1>
            <p style={{ marginTop: 22, maxWidth: 480, fontSize: 17, lineHeight: 1.7, color: "#5A4249" }}>
              Mon programme de 60 jours pour reprendre le sport avec des séances claires, une progression douce et une routine qui s’installe vraiment. Pensé pour les débutantes.
            </p>

            <ol style={{ marginTop: 44, borderTop: "1px solid #EFC3CF" }}>
              {STEPS.map(s => (
                <li key={s.n} style={{ display: "flex", gap: 20, alignItems: "baseline", padding: "20px 0", borderBottom: "1px solid #EFC3CF" }}>
                  <span className="serif" style={{ fontSize: 26, lineHeight: 1, fontStyle: "italic", color: "#C46F88", width: 40, flex: "none" }}>{s.n}</span>
                  <div>
                    <div className="t-h3" style={{ fontSize: 21 }}>{s.title}</div>
                    <p style={{ marginTop: 6, fontSize: 15, lineHeight: 1.6, color: "#5A4249" }}>{s.text}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* La commande */}
          <div className="shop-card">
            <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
              <div style={{ width: 92, flex: "none", rotate: "-4deg", boxShadow: "0 18px 30px -16px rgba(61,42,49,0.45)" }}>
                <PdfCover sizes="92px" priority />
              </div>
              <div>
                <p className="serif" style={{ fontSize: 20, lineHeight: 1.25 }}>{PDF_PRODUCT.name}</p>
                <p style={{ fontSize: 13, color: "#7A5D67", marginTop: 6 }}>Programme PDF · accès immédiat</p>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginTop: 26, paddingTop: 22, borderTop: "1px solid #EFC3CF" }}>
              <span className="kicker" style={{ fontSize: 11 }}>PAIEMENT UNIQUE</span>
              <span className="serif" style={{ fontSize: 44, lineHeight: 1, color: "#A8506A" }}>{PDF_PRODUCT.priceLabel}</span>
            </div>

            <ul style={{ display: "grid", gap: 12, marginTop: 22 }}>
              {INCLUDED.map(b => (
                <li key={b} style={{ display: "flex", gap: 12, alignItems: "flex-start", fontSize: 15, lineHeight: 1.5, color: "#3D2A31" }}>
                  <span style={{ marginTop: 2 }}><Check size={16} /></span>{b}
                </li>
              ))}
            </ul>

            {canceled && !error && (
              <div className="shop-notice" style={{ backgroundColor: "#FBE9EE", color: "#94435C" }}>
                Paiement annulé, aucun montant n’a été débité. Tu peux réessayer quand tu veux.
              </div>
            )}
            {error && (
              <div className="shop-notice" role="alert" style={{ backgroundColor: "#FBE4E4", color: "#9B2C2C" }}>{error}</div>
            )}

            <button type="button" className="btn btn-primary" onClick={handlePurchase} disabled={paying}
              style={{ width: "100%", minHeight: 60, marginTop: 26, border: "none", fontSize: 16, cursor: "pointer", fontFamily: "inherit" }}>
              {paying ? <><span className="spinner" /> Redirection vers Stripe…</> : <>Payer {PDF_PRODUCT.priceLabel} et commencer <Arrow /></>}
            </button>

            <p style={{ fontSize: 12, color: "#7A5D67", marginTop: 16, lineHeight: 1.6, textAlign: "center" }}>
              Tu seras redirigée vers Stripe pour payer. Tes données bancaires ne passent jamais par ce site.
            </p>
            <p className="hand" style={{ marginTop: 14, textAlign: "center", fontSize: 22, color: "#A8506A" }}>ta première séance t’attend ♡</p>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
